<template>
    <div class="w-100">
        <d-service-partner
            v-model = "showComanyEdit"
            :company-name = "searchInput"
            :roles  = "[ { id: 11, name: 'Ausf. Unternehmen',  label: 'AU', value: false } ]"
            @stored = "onCreated"
        />

        <v-autocomplete
            v-model           = "selected"
            :items            = "items"
            :rules            = "rules"
            :hint             = "hint"
            :label            = "label"
            :readonly         = "readonly"
            :disabled         = "readonly"
            :clearable        = "true"
            color             = "primary"
            item.id           = "id"
            item-text         = "name"
            @change           = "onChange"
            :return-object    = "true"
            :background-color = background
            :search-input.sync="searchInput"
            cache-items
            auto-select-first
            persistent-hint
        >
            <template v-slot:append-outer>
                <div v-if="!selected">
                    <c-toolbar-button
                        color   = "primary"
                        icon    = "mdi-plus"
                        size    = "22"
                        tooltip = "Neues Ausführendes Unternehmen anlegen"
                        @click  = "onCompany"
                    />
                </div>
            </template>
            <template v-slot:no-data>
                <div class="ml-2 mr-2" style="font-size: 15px">
                    Das Unternehmen wurde nicht gefunden. Mit + kann ein neues Unternehmen angelegt werden.
                </div>
            </template>
        </v-autocomplete>
    </div>
</template>

<script>

import CToolbarButton from "@/modules/core/components/utils/CToolbarButton";

export default {
    name: "IncManufacturer",

    components: {
        DServicePartner: () => import('@/modules/msd/company/servicepartner/components/controlls/DServicePartner'),
        CToolbarButton
    },

    props: {
        value: {
            required: true
        },

        label: {
            required: false,
            default: function () {
                return 'Ausführendes Unternehmen'
            }
        },

        rules: {
            required: false
        },

        hint: {
            required: false,
            type    : String,
            default : function () {
                return null;
            }
        },

        readonly: {
            required: false,
            type    : Boolean,
            default : function () {
                return false
            }
        },

        background: {
            required: false,
            type    : String,
            default : function () {
                return null
            }
        }
    },

    data: () => ({
        selected: null,
        showComanyEdit: false,
        searchInput: null
    }),

    mounted() {
        this.selected = this.value;
    },

    watch: {
        value: {
            deep: true,
            handler: function () {
                this.selected = this.value;
            }
        },
    },

    computed: {
        items () {
            return this.$store.getters.manufacturer;
        }
    },

    methods: {
        onChange (value) {
            if (value === '') {
                value = null;
            }

            this.$emit('input', value);
            this.$emit('changed', value);
        },

        onCompany () {
            this.showComanyEdit = true;
        },

        onCreated (company) {
            this.$store.dispatch("addManufacturer", company).then(() => {
                this.selected = company;
                this.$emit('input', this.selected);
                this.$emit('changed', this.selected);
            });
        }
    },
}
</script>

<style scoped>

</style>